<template>
  <section class="page-product-products-siblings">
    <!-- Title -->
    <div class="row-1">
      <h2 class="title m-right-16px" v-anim-reveal-text>
        {{ $t('pages.product.siblingsTitle', { name: parent.title }) }}
      </h2>
    </div>
    <div
      class="m-top-5 page-product-products-siblings__swiper"
      v-anim-parallax-element="{
        target: 'picture',
        offset: 10,
      }"
    >
      <WidgetSliderSwiper :slides="siblings" />
    </div>
  </section>
</template>

<script>
export default {
  name: 'PagesProductProductsSiblings',
}
</script>

<script setup>
const props = defineProps({
  siblings: Array,
  parent: Object,
})
</script>

<style lang="scss">
@import './style.scss';
</style>
